// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"5a61d336","488":"c34dc24a","732":"97df9ed1","977":"0f611c68"}[chunkId] + ".chunk.js");